import { CampaignCatalogueItem } from '@/client/campaigns';
import { CampaignsCataloguePageV2 } from '@/pages/campaigns/CampaignsCataloguePageV2';
import { FullscreenModal } from '@/ui/modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledModalHeader = styled.div`
  h1 {
    font-size: var(--heading-medium-font-size);
    line-height: var(--heading-medium-line-height);
    margin: 0 0 var(--xxsmall-padding) 0;
  }

  p {
    font-size: var(--small-font-size);
    margin: 0;
    color: var(--gray-deep);
  }
`;

type CatalogueSelectorModalProps = {
  visible: boolean;
  onHide: () => void;
  onSelect: (template: CampaignCatalogueItem) => void;
  entryPoint: 'direct-catalogue' | 'phishing-simulation';
};

export const CatalogueSelectorModal: React.FC<CatalogueSelectorModalProps> = ({
  visible,
  onHide,
  onSelect,
  entryPoint,
}) => {
  const { t } = useTranslation();

  const handleSelect = (template: CampaignCatalogueItem) => {
    onSelect(template);
    onHide();
  };

  return (
    <FullscreenModal
      visible={visible}
      onHide={onHide}
      contentPadding="var(--default-padding)"
      className="catalogue-selector-modal"
      header={
        <StyledModalHeader>
          <h1>{t('campaigns.catalogue.v2.title')}</h1>
        </StyledModalHeader>
      }
    >
      <CampaignsCataloguePageV2
        mode="select"
        onSelect={handleSelect}
        entryPoint={entryPoint}
      />
    </FullscreenModal>
  );
};
